export default {
  methods: {
    //DISPATCHES
    //Since the Event Handler listens for any error events with this `error-xyz` event name,
    //whenever you want to alert an error in your application you can invoke the Event-Handler with this method
    setError(err, prevent, actionEv) {
      if (!err || err.response.status >= 500) {
        err = {
          response: {
            status: "500",
            statusText: "server_error",
          },
        };
      }
      document.dispatchEvent(
        new CustomEvent("error-" + err.response.status, {
          detail: {
            preventDefault: prevent | false,
            callbackEvent: actionEv,
            data: err.response,
          },
        }),
      );
    },
    showLoader() {
      document.dispatchEvent(new CustomEvent("show-spinner-overlay"));
    },
    hideLoader() {
      document.dispatchEvent(new CustomEvent("hide-spinner-overlay"));
    },
  },
};
